<template>
  <section class="flex flex-col gap-10 md:gap-16">
    <div v-if="$slots.prepend" class="flex justify-center">
      <slot name="prepend" />
    </div>

    <header class="text-balance text-center">
      <slot name="header">
        <component
          :is="titleDefinition.tag"
          class="font-title m-auto max-w-[900px] text-2xl/normal md:text-3xl/normal"
        >
          <slot name="title">
            {{ titleDefinition.text }}
          </slot>
        </component>

        <div
          v-if="subtitle || $slots.subtitle"
          class="mx-auto mt-4 max-w-[800px] text-lg"
        >
          <slot name="subtitle">
            <component :is="subtitleDefinition.tag">
              {{ subtitleDefinition.text }}
            </component>
          </slot>
        </div>
      </slot>
    </header>

    <div v-if="$slots.default">
      <slot />
    </div>

    <div
      v-if="$slots.append"
      class="flex justify-center [&>[data-app-button]:only-child]:w-full sm:[&>[data-app-button]:only-child]:w-auto"
    >
      <slot name="append" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

const properties = defineProps<{
  title?:
    | I18nMessage
    | { tag: `h${1 | 2 | 3 | 4 | 5 | 6}` | string; text?: I18nMessage };
  subtitle?:
    | I18nMessage
    | { tag: `h${1 | 2 | 3 | 4 | 5 | 6}` | string; text?: I18nMessage };
}>();

const titleDefinition = computed(() => {
  if (typeof properties.title === "object") return properties.title;

  return {
    tag: "h2",
    text: properties.title,
  };
});

const subtitleDefinition = computed(() => {
  if (typeof properties.subtitle === "object") return properties.subtitle;

  return {
    tag: "p",
    text: properties.subtitle,
  };
});
</script>
